<header class="dash-toolbar" style="background-color: #00cec9;">
    <div>
        <h3 style="color: white;">
            <span style="color:#cecbcb">Welcome </span
      ><span style="font-size: 40px;color:#d63031">|</span>
        </h3>
    </div>

    <!--    <a href="#!" class="searchbox-toggle">
        <i class="fa fa-search"></i>
    </a>
   <!- <form class="searchbox" action="#!">
        <a href="#!" class="searchbox-toggle"> <i class="fa fa-arrow-left"></i> </a>
        <button type="submit" class="searchbox-submit"> <i class="fa fa-search"></i> </button>
        <input type="text" class="searchbox-input" placeholder="type to search">
    </form>-->
    <div class="tools">
        <div class="dropdown tools-item">
            <a class="" id="dropdownMenu1" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                <i class="fa fa-bell" style="color:white;margin-top: 15px"></i>
                <i class="tools-item-count"> 0"></i>
            </a>

            <div class="dropdown-menu dropdown-menu-right" aria-labelledby="dropdownMenu1"> 0">
                <a class="dropdown-item d-flex align-items-center">
                    <!--  <div class="mr-3">
                        <div class="icon-circle"> <i class="fa fa-user"></i> </div>
                    </div>-->
                    <div>
                        <div class="small text-gray-500"></div>
                        AppointmentNumber is booked
                    </div>
                </a>
            </div>
        </div>

        <!-- <a href="#!" class="tools-item">
            <i class="fa fa-user"></i>
            <i class="tools-item-count">4</i>
        </a>-->
        <!-- <i class="usr" *ngIf="!this.profileImage"></i> -->

        <div class="dropdown">

            <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">


                <!-- <a class="dropdown-item" href="#">Another action</a>
        <a class="dropdown-item" href="#">Something else here</a> -->
            </div>
        </div>
    </div>
</header>